import React from "react";
import AntdDrawer from 'antd/lib/drawer';
import { withError} from '@fishx/tracker';

export const Drawer = (props) => <AntdDrawer {...props} />

Drawer.displayName = 'Drawer';

export default withError(Drawer);


// WEBPACK FOOTER //
// ./src/components/drawer/index.tsx